import { Routes } from '@angular/router';
import { authRoutes } from './core/auth/auth.routes';
import { homeRoutes } from './pages/home/home.routes';
import { coursesRoutes } from './pages/course/course.routes';
import { problemRoutes } from './pages/problem/problem.routes';
import { topicRoutes } from './pages/topic/topic.routes';
import { passageRoutes } from './pages/passage/passage.route';

export const routes: Routes = [
  ...authRoutes,
  ...homeRoutes,
  ...coursesRoutes,
  ...problemRoutes,
  ...topicRoutes,
  ...passageRoutes,
];
